import React from 'react';
import useLegalPage from '../../hooks/useLegalPage';
import LegalPageLayout from '../../components/legal/LegalPageLayout';

const TermsOfServicePage = () => {
  const { page, loading, error, refetch } = useLegalPage('terms-of-service');

  return (
    <LegalPageLayout
      page={page}
      loading={loading}
      error={error}
      onRetry={refetch}
    />
  );
};

export default TermsOfServicePage;
